var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrivia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_2548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8893 13.1111C14.8579 13.1111 13.8688 13.5208 13.1395 14.2501C12.4102 14.9794 12.0004 15.9686 12.0004 17M12.0004 17V18.1111M12.0004 17C12.0004 15.9686 11.5907 14.9794 10.8614 14.2501C10.1321 13.5208 9.14294 13.1111 8.11154 13.1111M12.0004 18.1111C12.0004 19.1425 12.4102 20.1316 13.1395 20.8609C13.8688 21.5903 14.8579 22 15.8893 22C16.9207 22 17.9099 21.5903 18.6392 20.8609C19.3685 20.1316 19.7782 19.1425 19.7782 18.1111V16.1111M12.0004 18.1111C12.0004 19.1425 11.5907 20.1316 10.8614 20.8609C10.1321 21.5903 9.14294 22 8.11154 22C7.08015 22 6.09099 21.5903 5.36169 20.8609C4.63238 20.1316 4.22266 19.1425 4.22266 18.1111V16.1111",
    stroke: "#1C1356",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1102 16.4444C19.1416 16.4444 20.1308 16.0347 20.8601 15.3054C21.5894 14.5761 21.9991 13.5869 21.9991 12.5555C21.9991 11.5241 21.5894 10.535 20.8601 9.80566C20.1308 9.07635 19.1416 8.66663 18.1102 8.66663H17.5547",
    stroke: "#1C1356",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 9V5.88889C19.7778 4.85749 19.3681 3.86834 18.6388 3.13903C17.9094 2.40972 16.9203 2 15.8889 2C14.8575 2 13.8683 2.40972 13.139 3.13903C12.4097 3.86834 12 4.85749 12 5.88889M5.88889 16.4444C4.85749 16.4444 3.86834 16.0347 3.13903 15.3054C2.40972 14.5761 2 13.587 2 12.5556C2 11.5242 2.40972 10.535 3.13903 9.8057C3.86834 9.07639 4.85749 8.66667 5.88889 8.66667H6.44444",
    stroke: "#1C1356",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22266 9V5.88889C4.22266 4.85749 4.63238 3.86834 5.36169 3.13903C6.09099 2.40972 7.08015 2 8.11154 2C9.14294 2 10.1321 2.40972 10.8614 3.13903C11.5907 3.86834 12.0004 4.85749 12.0004 5.88889V17",
    stroke: "#1C1356",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_2548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivia);
export default __webpack_public_path__ + "static/media/trivia.92d10ae8.svg";
export { ForwardRef as ReactComponent };